// extracted by mini-css-extract-plugin
export default {"modal":"BasicModal_modal__qgfUk"};